<template>
    <n-card title="Configurações">
      <p>Aqui você poderá ajustar as preferências do sistema.</p>
    </n-card>
  </template>
  